import React from 'react'

export default class Image extends React.Component {
  state = {
    open: false,
  }

  lock() {
    document.body.classList.add('lock');
  }

  unlock() {
    document.body.classList.remove('lock');
  }

  open = () => {
    this.setState({ open: true })
    this.lock();
  }

  close = () => {
    this.setState({ open: false })
    this.unlock()
  }

  render() {
    const { src } = this.props
    return (
      <div className="LightBox__container">
        <div
          key={src}
          className="LightBox__img"
          style={{ backgroundImage: `url(${src})` }}
          onClick={this.open}
        />
        <div
          className={`LightBox__overlay ${
            this.state.open ? 'LightBox__overlay-open' : ''
          }`}
          onClick={this.close}
        >
          <div className="LightBox__wrapper">
            <img src={src} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LightBox/Image.js